import { z } from 'zod';

export const CrewRatesSchema = z.object({
  tearoff_tearoff_1: z.string(),
  tearoff_additional_layer_upcharge_1: z.string(),
  tearoff_plywood_replacement_1: z.string(),
  install_rates_walk_on_1: z.string(),
  install_rates_4_12_1: z.string(),
  install_rates_5_12_1: z.string(),
  install_rates_6_12_1: z.string(),
  install_rates_7_12_1: z.string(),
  install_rates_8_12_1: z.string(),
  install_rates_9_12_1: z.string(),
  install_rates_10_12_1: z.string(),
  install_rates_11_12_1: z.string(),
  install_rates_12_12_1: z.string(),
  install_rates_ridge_1: z.string(),
  install_rates_starter_1: z.string(),
  install_rates_height_upcharge_1: z.string(),
  extras_skylights_small_install_1: z.string(),
  extras_skylights_large_install_1: z.string(),
  extras_chimney_flashings_small_1: z.string(),
  extras_chimney_flashings_large_1: z.string(),
  extras_z_flashing_small_1: z.string(),
  extras_z_flashing_large_1: z.string(),
  extras_cut_in_vents_1: z.string(),
  extras_cut_in_ridge_vent_1: z.string(),
  extras_install_ridge_vent_1: z.string(),
  extras_power_vents_1: z.string(),
  extras_plug_vents_1: z.string(),
  extras_gutter_apron_1: z.string(),
  extras_drip_edge_1: z.string(),
  extras_step_flashing_1: z.string(),
  extras_straight_flashing_1: z.string(),
});

export type CrewRates = z.infer<typeof CrewRatesSchema>; 